module.exports = __webpack_public_path__ + "img/asDuCoeur.d3e1538e.png";